/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Roles_Manage_Permissions_TitleInputs */

const en_admin_roles_manage_permissions_title = /** @type {(inputs: Admin_Roles_Manage_Permissions_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage Role Permissions`)
};

/**
* | output |
* | --- |
* | "Manage Role Permissions" |
*
* @param {Admin_Roles_Manage_Permissions_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_roles_manage_permissions_title = /** @type {((inputs?: Admin_Roles_Manage_Permissions_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Roles_Manage_Permissions_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_roles_manage_permissions_title(inputs)
});
export { admin_roles_manage_permissions_title as "admin.roles.manage_permissions_title" }